// Shared state across the admin dashboard pages (Overview, Students, Student Detail).
// Mirrors the teacher-side `studentDataStore` Zustand pattern: timeRange selection
// persists when navigating between admin pages. The hook layer also syncs the
// active value into the `?range=` query param so URLs stay shareable, and the
// `persist` middleware keeps the choice across reloads.
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { type TimeRange } from '~/services/administrator/useSchoolBehaviorReportQuery';

export const DEFAULT_TIME_RANGE: TimeRange = '30d';

type AdminDashboardStore = {
  timeRange: TimeRange;
  setTimeRange: (timeRange: TimeRange) => void;
};

export const adminDashboardStore = create<AdminDashboardStore>()(
  persist(
    (set) => ({
      timeRange: DEFAULT_TIME_RANGE,
      setTimeRange: (timeRange) => set({ timeRange }),
    }),
    { name: 'adminDashboardStorage' },
  ),
);
